import {
  FAILED_TO_GET_TOBAS, FAILED_TO_GET_VALID_TOBAS,
  GET_TOBAS,
  GET_VALID_TOBAS,
  RECEIVE_ALL_TOBAS, RECEIVE_ALL_VALID_TOBAS,
  RECEIVE_DELETE_TOBA_RESPONSE
} from "../actions";
import _ from 'lodash';

const defaultState = {
  fetching: false,
  tobas: [],
  validTobas: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case RECEIVE_DELETE_TOBA_RESPONSE:
      let newTobas = [...state.tobas];
      newTobas = _.filter(newTobas, t => {return t.id !== action.payload.body.id});
      return {
        ...state,
        tobas: newTobas
      };
    case GET_TOBAS:
      return {
        ...state,
        fetching: true
      };
    case RECEIVE_ALL_TOBAS:
      return {
        ...state,
        fetching: false,
        tobas: action.payload.body.data
      };
    case FAILED_TO_GET_TOBAS:
      return {
        ...state,
        fetching: false
      };
    case GET_VALID_TOBAS:
      return {
        ...state,
        fetching: true
      };
    case RECEIVE_ALL_VALID_TOBAS:
      return {
        ...state,
        fetching: false,
        validTobas: action.payload.body.data
      };
    case FAILED_TO_GET_VALID_TOBAS:
      return {
        ...state,
        fetching: false
      };
    default:
      return state;
  }
}
